<template>
  <el-dialog
    title="Create New Budget"
    visible
    :fullscreen="isFullscreen"
    @close="$emit('update:isShow', false)"
  >
    <BudgetEditForm ref="form" />
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isFullscreen = !isFullscreen">
        <FontAwesomeIcon
          v-if="isFullscreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button
        @click.native="$emit('update:isShow', false)"
      >
        Cancel
      </el-button>
      <el-button
        type="primary"
        @click.native="create"
      >
        Create
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import BudgetEditForm from '@/components/Application/Sales/Budgets/BudgetEditForm'
export default {
  components: {
    BudgetEditForm
  },
  props: {
    isShow: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      isFullscreen: false
    }
  },
  methods: {
    async create () {
      if (await this.$refs.form.validate()) {
        console.log('Validated')
      }
    }
  }
}
</script>

<style>

</style>
